import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useLocale, useT } from "@trust/i18n";
import { getSimilarGuides } from "./api";

/**
 * 门户详情页右侧「相似指南」卡(P3.6)— GET /guides/{id}/similar top5。
 * 仅桌面渲染(挂在 300px 右栏,父级 max-portal:hidden);接口失败/空结果不渲染卡片。
 * 每行:标题链接(跳对应详情页)+ 相似度百分比(portal-gold)。
 */
export function SimilarGuidesCard({ guideId }: { guideId: string }) {
  const t = useT();
  const locale = useLocale();

  const q = useQuery({
    queryKey: ["guide-similar", guideId],
    queryFn: () => getSimilarGuides(guideId),
    retry: false,
    staleTime: 5 * 60_000,
  });

  if (!q.data || q.data.length === 0) return null;

  return (
    <div className="mt-[15px] rounded-[20px] bg-white p-[20px]">
      <div className="text-[20px] font-semibold text-[#333333]">{t("similarGuides.title")}</div>
      <div className="mt-[15px] space-y-[12px]">
        {q.data.map((s) => (
          <div key={s.guide_id} className="flex items-start justify-between gap-[8px]">
            <Link
              to="/inx/guide/$guideId"
              params={{ guideId: String(s.guide_id) }}
              className="line-clamp-2 flex-1 text-[14px] leading-[20px] text-[#333333] no-underline hover:text-portal-primary"
            >
              {locale === "en" ? s.title_en || s.title : s.title}
            </Link>
            <span className="shrink-0 text-[13px] text-portal-gold">
              {Math.round(s.score * 100)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
